export const TWITTER_OVERVIEW_MULTI_BRAND = [
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channel: 'TWITTER',
      metric: 'TOTAL_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 0,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channel: 'TWITTER',
      metric: 'NET_NEW_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 4,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channel: 'TWITTER',
      metric: 'FOLLOWER_GROWTH_RATE',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 4,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channel: 'TWITTER',
      metric: 'AVG_ENGAGEMENT_RATE',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 8,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channel: 'TWITTER',
      metric: 'LINK_CLICKS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 8,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channel: 'TWITTER',
      metric: 'IMPRESSIONS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 12,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channel: 'TWITTER',
      metric: 'ORGANIC_VIDEO_VIEWS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 12,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channel: 'TWITTER',
      metric: 'TOTAL_ENGAGEMENTS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 16,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channel: 'TWITTER',
      metric: 'REPLIES',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 16,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channel: 'TWITTER',
      metric: 'RETWEETS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 0,
    y: 20,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channel: 'TWITTER',
      metric: 'QUOTE_TWEETS',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'TOTAL_GROUPED_METRIC',
    w: 3,
    x: 3,
    y: 20,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channel: 'TWITTER',
      metric: 'LIKES',
      content_tag_ids: ['content_tag_ids'],
      aggregate_by: 'BRAND',
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 24,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channels: ['TWITTER'],
      metric: 'NET_NEW_FOLLOWERS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 24,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channels: ['TWITTER'],
      metric: 'AVG_ENGAGEMENT_RATE',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 0,
    y: 28,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channels: ['TWITTER'],
      metric: 'ORGANIC_VIDEO_VIEWS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'GRAPH',
    w: 3,
    x: 3,
    y: 28,
    meta: {
      brand_ids: ['{brandId0}', '{brandId1}', '{brandId2}'],
      channels: ['TWITTER'],
      metric: 'IMPRESSIONS',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 32,
    meta: {
      name: 'Tweet Performance',
    },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 33,
    meta: {
      brand_ids: ['{brandId0}'],
      channel: 'TWITTER',
      metric: 'ENGAGEMENT_RATE',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 37,
    meta: {
      brand_ids: ['{brandId0}'],
      channel: 'TWITTER',
      metric: 'VIDEO_VIEWS',
      sort_order: 'DESC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
  {
    h: 4,
    type: 'CONTENT_OWNED',
    w: 6,
    x: 0,
    y: 41,
    meta: {
      brand_ids: ['{brandId0}'],
      channel: 'TWITTER',
      metric: 'ENGAGEMENT_RATE',
      sort_order: 'ASC',
      content_tag_ids: ['content_tag_ids'],
    },
  },
];
